// scrollbarStyles.js
export const getScrollbarStyles = () => ({
  '& *::-webkit-scrollbar': {
    width: '16px',
    height: '16px',
  },
  '& *::-webkit-scrollbar-track': {
    background: '#f0f0f0',
    borderRadius: '8px',
  },
  '& *::-webkit-scrollbar-thumb': {
    backgroundColor: '#aaa',
    borderRadius: '8px',
  },
  '& *::-webkit-scrollbar-thumb:hover': {
    backgroundColor: '#888',
  },
  overflow: 'scroll',
});

export const getResponsiveBoxStyles = () => ({
  height: {
    xs: '60vh',
    sm: '65vh',
    md: '70vh',
    lg: '75vh',
    xl: '80vh',
  },
  width: {
    xs: '98vw',
    sm: '90vw',
    md: '90vw',
    lg: '95vw',
    xl: '95vw',
  },
});
